<template>
  <Content @back="$router.go(-1)">
    <template v-slot:nav_left>{{orgLookInfo.organ.organShortName || '--'}}</template>
    <template v-slot:content_right>
      <div class="mainHead">
        <div class="headInfo">
          <div class="logo">
            <img :src="orgLookInfo.organ.banner || memberImg" alt="" @error="orgLookInfo.organ.banner = memberImg">
          </div>
          <div class="info">
            <p>区体育行政部门全称：{{orgLookInfo.organ.organName}}</p>
            <div class="row">
              <p >区体育行政部门级别：{{orgLookInfo.organ.organType | orgType}}</p>
              <p class="item">区体育行政部门地址：{{orgLookInfo.organ.cityName}}{{orgLookInfo.organ.countyName}}</p>
            </div>
            <div class="row">
              <p >管理员姓名：{{orgLookInfo.user.idName}}</p>
              <p class="item">管理员手机号：<yioks-privacy-text type="phone" :value="orgLookInfo.user.phone" /></p>
            </div>
            <div class="row">
              <p >区体育行政部门状态：{{orgLookInfo.organ.status | statusFilter }}</p>
<!--              <p class="item">区体育行政部门球队数量：{{orgLookInfo.organ.playerTeamNum || '&#45;&#45;'}}</p>-->
              <p class="item">区体育行政部门培训机构数量：{{orgLookInfo.organ.youthNum || '--'}}</p>
            </div>
          </div>
          <div class="btn">
            <div v-if="userRole === 'system'" class="bg_btn" @click="editOrg">编辑信息</div>
          </div>
        </div>
      </div>
      <div class="mainInfo">
        <div class="select_wrap">
          <p class="title">
            <strong style="cursor: pointer" :class="type ==='trainCamp' ? 'current':null" @click="changeType('trainCamp')">精英集训队管理</strong>
            <template v-if="$store.getters.sysHostType === 'youth'">
              <strong  style="margin: 0 5px">/</strong>
              <strong style="cursor: pointer" :class="type ==='youth' ? 'current':null" @click="changeType('youth')">精英机构</strong>
            </template>
            <template v-if="$store.getters.sysHostType === 'club'">
              <strong  style="margin: 0 5px">/</strong>
              <strong style="cursor: pointer" :class="type ==='club' ? 'current':null" @click="changeType('club')">精英机构/基地管理</strong>
            </template>

          </p>
          <div class="select_box">
            <select
                v-model="selectVal.provinceCode"
                class="yioks_select"
                style="width: 130px;height: 35px;"
                @change="changeProvince"
                  >
              <option value=''>全部省份</option>
              <option
                v-for="item in selectRegions"
                :key="item.code"
                :value="item.code"
              >{{ item.name }}</option>
            </select>
            <select
              v-model="selectVal.cityCode"
              class="yioks_select"
              style="width: 130px;height: 35px;"
              @change="changeQuery(true)" >
              <option value=''>全部城市</option>
              <option
                v-for="item in selectCityList"
                :key="item.code"
                :value="item.code"
              >{{ item.name }}</option>
            </select>
            <select
                    v-model="selectVal.status"
                    class="yioks_select"
                    style="width: 130px;height: 35px;"
                    @change="changeQuery(true)" >
              <option value=''>全部状态</option>
              <option
                v-for="item in centerStatusList"
                :key="item.status"
                :value="item.status"
              >{{ item.name }}</option>
            </select>
          </div>
        </div>
        <div v-if="showList" class="list">
          <div class="scrollArea">
            <vue-scroll >
                <div
                    v-for="(item, index) in centerList"
                    :key="index"
                    class="tr">
                  <div class="item">
                    <div class="img">
                      <img v-if="type==='youth'" :src="item.banner || centerImg" @error="item.banner = centerImg">
                      <img v-if="type==='club'" :src="item.banner || clubImg" @error="item.banner = clubImg">
                      <img v-if="type==='trainCamp'" :src="item.banner || trainCampImg" @error="item.banner = trainCampImg">
                    </div>
                    <div class="info">
                      <p class="title">{{item.youthShortName}}</p>
                      <p><span v-if="type==='youth'">青训中心所在地</span>
                        <span v-else-if="type==='club'">精英机构/基地所在地</span>
                        <span v-else>精英集训队所在地</span>：{{item.provinceName}}{{item.cityName}}</p>
                      <p v-if="type!=='trainCamp'">管理员姓名：{{item.adminName}}</p>
                      <p><span v-if="type==='youth'">青训中心状态</span>
                        <span v-else-if="type==='club'">精英机构/基地状态</span>
                        <span v-else>精英集训队状态</span>：{{item.status | statusFilter }}
                      </p>
                    </div>
                    <div class="opt">
                        <div class="bg_btn" @click="goInfo(item.uuid)">查看详情</div>
                    </div>
                  </div>
                  </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <el-dialog
        :visible.sync="isEdit"
        width="600px"
        title="编辑区体育行政部门"
        :close-on-click-modal="false"
        top="10vh"
        custom-class="yioks_alert"
      >
        <el-form
          ref="orgInfo"
          :model="orgInfo"
          :rules="formRules"
          label-width="160px"
          style="height: 490px"
          class="demo-ruleForm">
          <vue-scroll :ops='ops'>
            <el-row>
              <el-form-item label="区体育行政部门级别" prop="organType">
                <el-radio-group v-model="orgInfo.organType" disabled>
                  <el-radio label="PROVINCE">省级</el-radio>
                  <el-radio label="CITY">市级</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row class="provinceOrgInfo" >
              <div class="label">区体育行政部门所在地</div>
              <el-col :span="7">
                <el-form-item  label-width="0" prop="provinceCode">
                  <el-select v-model="orgInfo.provinceCode" placeholder="请选择省">
                    <el-option
                      v-for="item in regions"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="orgInfo.organType==='CITY'" :span="7" :offset="1">
                <el-form-item  label-width="0" prop="cityCode">
                  <el-select
                    v-model="orgInfo.cityCode"
                    placeholder="请选择市"
                    @change="changeCity" >
                    <el-option
                      v-for="item in cityList"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="区体育行政部门全称" prop="organName">
                  <el-input v-model.trim="orgInfo.organName" disabled placeholder="请输入区体育行政部门名称(50个字以内)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="区体育行政部门简称" prop="organShortName">
                  <el-input v-model.trim="orgInfo.organShortName" disabled placeholder="请输入区体育行政部门简称(20个字以内)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="管理员姓名" prop="idName">
                  <el-input v-model.trim="orgInfo.idName" placeholder="请输入区体育行政部门管理员姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="区体育行政部门用户名">
                  <el-input v-model.trim="orgInfo.loginName" disabled placeholder="请输入区体育行政部门身份证号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="管理员手机号" prop="phone">
                  <el-input v-model.trim="orgInfo.phone" placeholder="请输入区体育行政部门管理员手机号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="20">
                <el-form-item label="区体育行政部门状态" prop="status">
                  <el-select v-model.trim="orgInfo.status" style="width: 100%">
                    <el-option
                      v-for="(item, index) in centerStatusList"
                      :key="index"
                      :label="item.name"
                      :value="item.status"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input v-model.trim="orgInfo.password" placeholder="请输入将要更改的密码" type="password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input  v-model.trim="orgInfo.confirmPassword" placeholder="请输入确认密码" type="password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="21">
                <el-form-item label="上传logo">
                  <UploadImg :imgUrl.sync='orgInfo.banner ' :errImg="centerImg" :avatarUrl.sync="img" />
                  <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
                </el-form-item>
              </el-col>
            </el-row>
          </vue-scroll>
        </el-form>
        <div class="tip">* 管理员身份证号将作为登录帐号，手机号作为青训中心的初始密码。</div>
        <div class="dialog_btn_wrap">
          <el-button
            type="primary"
            style="margin-right:20px"
            :loading="addbtnLoading"
            @click="addOrgan"
          >{{$t('confirm')}}</el-button>
          <el-button type="danger" @click="isEdit = false">{{$t('cancel')}}</el-button>
        </div>
      </el-dialog>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import org from '@/api/org'
import center from '@/api/center'
import trainCamp from '@/api/trainCamp'
import club from '@/api/club'
import memberImg from '@/assets/images/common/member.png'
import { centerStatusList } from '@/utils/yioks_data'
import rulesMixin from '@/utils/formRules/org'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import auth from '@/api/auth'
import regions from '@/utils/regions'
import { centerStatus, orgTypeStatus } from '@/utils/yioks_filter'
import { ops } from '@/utils/scrollIndialog'
import centerImg from '@/assets/images/common/center.png'
import clubImg from '@/assets/images/common/club.png'
import trainCampImg from '@/assets/images/common/trainCamp.png'
import storage from '@/utils/storage'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'UploadImg': () => import('@/components/UploadImg')
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    },
    orgType (val) {
      return orgTypeStatus(val)
    }
  },
  mixins: [rulesMixin],
  data () {
    return {
      userRole: storage.get('userInfo').userRole,
      trainCampImg,
      clubImg,
      centerImg,
      ops,
      img: '',
      type: 'trainCamp',
      regions,
      editing: false,
      memberImg,
      uuid: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      addCenterBtn: false,
      orgLookInfo: {
        user: {},
        organ: {}
      },
      orgInfo: {
        idName: '',
        loginName: '',
        organType: '',
        organName: '',
        organShortName: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        phone: '',
        status: '',
        password: '',
        banner: ''
      },
      loading: true,
      addbtnLoading: false,
      isEdit: false,
      selectVal: {
        cityCode: '',
        provinceCode: '',
        status: ''
      },
      centerList: [], // 青训中心列表,
      cityList: [],
      selectCityList: [],
      selectRegions: regions,
      centerStatusList
    }
  },
  watch: {
    // 'selectVal.provinceCode': {
    //   handler (val) {
    //     if (val) {
    //       this.regions.forEach(item => {
    //         if (item.code === val) {
    //           this.selectCityList = item.city
    //           this.selectVal.cityCode = this.selectCityList[0].code
    //         }
    //       })
    //     } else {
    //       this.selectCityList = []
    //       this.selectVal.cityCode = ''
    //     }
    //     this.getCenterList()
    //   }
    // },
    'orgInfo.provinceCode': {
      handler (val) {
        this.regions.forEach(item => {
          if (item.code === val) {
            this.cityList = item.city
            if (this.orgInfo.organType === 'PROVINCE') {
              this.$set(this.orgInfo, 'cityCode', this.cityList[0].code)
              this.$set(this.orgInfo, 'cityName', this.cityList[0].name)
            } else {
              this.$set(this.orgInfo, 'cityCode', '')
              this.$set(this.orgInfo, 'cityName', '')
            }
            this.$set(this.orgInfo, 'provinceName', item.name)
          }
        })
      }
    },
    page () {
      this.changeQuery()
    }
  },
  created () {
    // const uuid = this.$route.query.uuid
    const { page, cityCode, provinceCode, keyWord, uuid, status, type } = this.$route.query
    page && (this.page = Number(page))
    cityCode && (this.$set(this.selectVal, 'cityCode', cityCode))
    provinceCode && (this.$set(this.selectVal, 'provinceCode', provinceCode))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    status && (this.$set(this.selectVal, 'status', status))
    type && (this.type = type)
    this.uuid = uuid
    // this.getCoachAccount()
    provinceCode && this.setCityList()
    this.getCenterInfo()
    this.getCenterList()
  },

  mounted() {
    // this.setdefaultType()
  },

  methods: {

    setdefaultType() {
      if(this.$store.getters.sysHostType === 'youth' ) {
        this.type = 'youth';
      } else {
        this.type = 'trainCamp'
      }
    },
    getCenterInfo () {
      org.getOrgInfo(this.uuid).then((res) => {
        this.orgLookInfo.user = res.user
        this.orgLookInfo.organ = res.organ
        const { idName, loginName, phone } = res.user
        const { cityName, cityCode, organType, provinceName, provinceCode, organName, organShortName, status, id, banner } = res.organ
        this.orgInfo = {
          idName,
          cityName,
          id,
          cityCode: cityCode === 0 ? '' : String(cityCode),
          provinceName,
          organType,
          provinceCode: provinceCode === 0 ? '' : String(provinceCode),
          organName,
          phone,
          loginName,
          organShortName,
          status,
          banner: banner || ''
        }
      })
    },
    getCenterList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      if (this.type === 'youth') {
        request = center.getCenterListBySystem
      } else if (this.type === 'club') {
        request = club.getCenterListBySystem
      } else {
        request = trainCamp.getCenterListBySystem
      }
      request({ page: this.page, size: this.pageSize, organUuid: this.uuid, provinceCode: this.selectVal.provinceCode, cityCode: this.selectVal.cityCode, status: this.selectVal.status }).then((res) => {
        this.loading = false
        let data = res.content
        this.total = res.totalElements
        if (data.length) {
          this.centerList = data
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    changeCity () {
      this.centerInfo.cityName = this.cityList.find(item => {
        return item.code === this.centerInfo.cityCode
      }).name
    },
    changeProvince () {
      if (this.selectVal.provinceCode) {
        this.selectRegions.forEach(item => {
          if (item.code === this.selectVal.provinceCode) {
            this.selectCityList = item.city
            this.$set(this.selectVal, 'cityCode', '')
          }
        })
      } else {
        this.selectCityList = []
        this.$set(this.selectVal, 'cityCode', '')
      }
      this.changeQuery(true)
    },
    editOrg () {
      const { idName, loginName, phone } = this.orgLookInfo.user
      const { cityName, cityCode, organType, provinceName, provinceCode, organName, organShortName, status, id, banner } = this.orgLookInfo.organ
      this.orgInfo = {
        idName,
        cityName,
        id,
        cityCode: cityCode === 0 ? '' : String(cityCode),
        provinceName,
        organType,
        provinceCode: provinceCode === 0 ? '' : String(provinceCode),
        organName,
        phone,
        loginName,
        organShortName,
        status,
        banner: banner || ''
      }
      this.isEdit = true
    },
    changeType (val) {
      if (val === this.type) return
      this.type = val
      this.$set(this.selectVal, 'provinceCode', '')
      this.$set(this.selectVal, 'cityCode', '')
      this.$set(this.selectVal, 'status', '')
      this.cityList = []
      this.changeQuery(true)
    },
    addOrgan () {
      this.$refs['orgInfo'].validate(async valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = org.updateOrg
          let requestData = {
            guoziOrgan: {
              provinceCode: this.orgInfo.provinceCode,
              provinceName: this.orgInfo.provinceName,
              cityCode: this.orgInfo.cityCode,
              cityName: this.orgInfo.cityName,
              organName: this.orgInfo.organName,
              organShortName: this.orgInfo.organShortName,
              organType: this.orgInfo.organType,
              id: this.orgInfo.id,
              status: this.orgInfo.status,
              banner: this.orgInfo.banner
            },
            userForm: {
              phone: this.orgInfo.phone,
              idName: this.orgInfo.idName,
              loginName: this.orgInfo.loginName
            }
          }
          if (this.orgInfo.password) {
            let username = this.orgInfo.loginName
            // // ras 加密
            let publicKey = await auth.getPublicKey(username)
            let encryptor = new JSEncrypt()
            encryptor.setPublicKey(publicKey)
            let rsaPassword = encryptor.encrypt(this.orgInfo.password)
            requestData.userForm.password = rsaPassword
          }
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            if (res.code) {
              // if (res.code === 'PhoneRepeat') {
              //   this.PhoneRepeat = true
              //   this.$refs['centerInfo'].validateField('phone')
              // }
              // if (res.code === 'IdNumberRepeat') {
              //   this.IdNumberRepeat = true
              //   this.$refs['centerInfo'].validateField('loginName')
              // }
              this.$message.error(res.msg)
            } else {
              this.getCenterInfo()
              this.isEdit = false
              this.editIng = false
              this.addbtnLoading = false
            }
          }).catch(err => {
            this.addbtnLoading = false
            this.editIng = false
            console.error(err)
          })
        }
      })
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          cityCode: this.selectVal.cityCode,
          provinceCode: this.selectVal.provinceCode,
          keyWord: this.selectVal.keyWord,
          uuid: this.uuid,
          status: this.selectVal.status,
          type: this.type
        }
      })
      this.getCenterList()
    },
    setCityList () {
      this.selectRegions.forEach(item => {
        if (item.code === this.selectVal.provinceCode) {
          this.selectCityList = item.city
          // this.selectVal.cityCode = this.selectCityList[0].code
        }
      })
    },
    goInfo (uuid) {
      let path
      if (this.type === 'youth') {
        path = '/center/info'
      } else if (this.type === 'club') {
        path = '/club/info'
      } else {
        path = '/trainCamp/info'
      }
      this.$router.push({
        path,
        query: {
          uuid
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainHead
    padding 15px 20px 0
    .headInfo
      display flex
      padding-bottom 20px
      border-bottom 1px solid white
      .logo
        display: flex;
        justify-content: center;
        align-items: center
        img
          width 105px
      .info
        width: calc(100% - 200px);
        padding 0 10px
        .row
          margin 10px 0
          display flex
          .item
            margin 0 15px
      .btn
        width 105px
        display: flex;
        justify-content: center;
        align-items: center
  .mainInfo
    height:430px
    .select_wrap
      display flex
      justify-content space-between
      padding 10px 20px 5px
      .title
        font-size 20px
        .current
          color $green_color
          font-size 24px
    .list
      height 375px
      .scrollArea
        height 100%
        .tr
          padding 0 20px
          .item
            display flex
            align-items center
            padding 15px 0
            border-bottom 1px solid #fff
            .img
              img
                width 100px
            .info
              width: calc(100% - 240px);
              padding 0 10px
              p
                margin-bottom 10px
                &:last-child
                  margin-bottom 0
              .title
                font-size 20px
            .opt
              padding 0 10px
              width 140px
              display flex
              align-items center
              justify-content center
</style>
<style lang="stylus">
  .provinceOrgInfo
    display flex
    .label
      width: 160px;
      height 40px
      line-height 40px
      text-align center
      &:before
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
.bg_btn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  &:hover
    background #5ac8fa
</style>
